import { Box, Button, CircularProgress, LinearProgress, useTheme } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import './unityStyle.module.scss';
import { getEventListeners } from "events";
import { connect, useDispatch } from "react-redux";
import { digitalTwinActions } from "../../../store/reducers/digital-twin";
import { useLocation, useParams } from "react-router-dom";
import { pageActions } from "../../../store/reducers/page-actions";
import { get } from "lodash";
import { useAuth } from "react-oidc-context";

const UnityPlayer = ({ sceneData, libraryData }: any) => {
    const auth: any = useAuth();
    const dispatch = useDispatch();
    const themeData :any =useTheme();
    const { dt_id, application_mode } = useParams();
    const { pathname } = useLocation();
    const [appLoaded, setAppLoaded] = useState<any>(true);

    const {
        unityProvider,
        isLoaded,
        loadingProgression,
        sendMessage,
        unload,
        addEventListener,
        removeEventListener,
        // UNSAFE__detachAndUnloadImmediate
    } = useUnityContext({
        loaderUrl: '/webgl/Build/WebGLExport.loader.js',
        dataUrl: '/webgl/Build/WebGLExport.data',
        frameworkUrl: '/webgl/Build/WebGLExport.framework.js',
        codeUrl: '/webgl/Build/WebGLExport.wasm',
    });

    useEffect(() => {
        const payload: any = {
            dt_id: dt_id,
            application_mode: application_mode
        }
        dispatch(digitalTwinActions.sceneDataRequest(payload))
    }, [dt_id, application_mode])

    useEffect(() => {
        if (pathname.length) {
            const pathnamesTemp: any = pathname.split('/').filter(Boolean);
            if (pathnamesTemp.length) {
                const pathnamesData: any = pathnamesTemp
                    .filter((i: any, index: number) => index != 2)
                    .map((item: any, index: number) => {
                        if (index == 0) {
                            return { route: pathnamesTemp[0], pathName: item, navigate: true };
                        } else if (index == 1) {
                            return { route: '', pathName: application_mode, navigate: false };
                        } else {
                            return { route: '', pathName: item, navigate: false };
                        }
                    });
                dispatch(pageActions.setPagePath(pathnamesData));
                return () => {
                    const data: any = [];
                    dispatch(pageActions.setPagePath(data));
                };
            }
        }
    }, [sceneData])

    const handleInitialData: any = useCallback(() => {
        sendMessage('DataAndCommManager', 'onInitializationHeaderReceived', JSON.stringify(sceneData))
    }, [isLoaded])

    useEffect(() => {
        addEventListener('FetchInitializationHeader', handleInitialData)
        return () => {
            removeEventListener('FetchInitializationHeader', handleInitialData);
        };
    }, [isLoaded, sendMessage])

    const handleClick = useCallback(async () => {
        await unload();
    }, [unload])

    useEffect(() => {
        if (isLoaded === true) {
            sendMessage('DataAndCommManager', 'onApplicationLoaded',get(auth,'user.access_token',''));
            // sendMessage('DataAndCommManager', 'onApplicationLoaded', 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJKak9iU2RLS0twMkh5c3VhbEFJN2J0bk9oYURRWUtQQWdyZ0E5X3ZyUkpZIn0.eyJleHAiOjE3MjM1NTk3MTUsImlhdCI6MTcyMzUyMzcxNSwiYXV0aF90aW1lIjoxNzIzNTIzNzE1LCJqdGkiOiI0OTBmOGQ3YS04OWJmLTQ1YmItODc2MS1jMTllMmU4YTI3YzMiLCJpc3MiOiJodHRwOi8vZWMyLTMtMTA4LTI1MS0yMjYuYXAtc291dGgtMS5jb21wdXRlLmFtYXpvbmF3cy5jb20vYXV0aC9yZWFsbXMvaW90X2luX2JveCIsImF1ZCI6ImFjY291bnQiLCJzdWIiOiJiYjI4ZGY4ZC0wM2JkLTQ0NTktOTg2Ny0yZGUwNmZmMDQ1ZDkiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJpb3QtaW4tYm94LXVpIiwic2Vzc2lvbl9zdGF0ZSI6IjE1YTE5ODNmLTllZDItNGMwOC05ZDI3LWNiOTU2NGRjODk5MyIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cDovL2VjMi0zLTEwOC0yNTEtMjI2LmFwLXNvdXRoLTEuY29tcHV0ZS5hbWF6b25hd3MuY29tIiwiaHR0cDovL2VjMi0zLTEwOC0yNTEtMjI2LmFwLXNvdXRoLTEuY29tcHV0ZS5hbWF6b25hd3MuY29tOjkwODAiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIm9mZmxpbmVfYWNjZXNzIiwiYWRtaW4iLCJ1bWFfYXV0aG9yaXphdGlvbiIsImRlZmF1bHQtcm9sZXMtaW90X2luX2JveCJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoib3BlbmlkIGVtYWlsIHByb2ZpbGUgdGVuYW50Iiwic2lkIjoiMTVhMTk4M2YtOWVkMi00YzA4LTlkMjctY2I5NTY0ZGM4OTkzIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoiQWJoaWxhc2hLdW1hciBUaXdhcmkiLCJncm91cHMiOlsib2ZmbGluZV9hY2Nlc3MiLCJhZG1pbiIsInVtYV9hdXRob3JpemF0aW9uIiwiZGVmYXVsdC1yb2xlcy1pb3RfaW5fYm94Il0sInByZWZlcnJlZF91c2VybmFtZSI6ImFiaGlsYXNoa3VtYXIudGl3YXJpQGhhcm1hbi5jb20iLCJnaXZlbl9uYW1lIjoiQWJoaWxhc2hLdW1hciIsImZhbWlseV9uYW1lIjoiVGl3YXJpIiwidGVuYW50IjpbIi9oYXJtYW4iXSwiZW1haWwiOiJhYmhpbGFzaGt1bWFyLnRpd2FyaUBoYXJtYW4uY29tIn0.Lx-eXCu8yQ7dsZFC_fryT0NHdfPZoQKnaHqckz7PWI67FUto2IE8JUT4ZemKoi7LjOM8RFUWI-DPKjNX9XjJV7Pi03yuNMBtp7kGfBorFyCftqTdEr8nmOdTmRjdzhkjjrhkl9qZ1VcXMr6odGL9wvxxQ0D2pnKuqtDCTmZ2z-2_eXN_v-y32etjwgxF-cmLrWJaMBfiJZF-Luw8j6C9qbE_nHI2x9vipdQy-pLfcRlXDnmXMT-q_l_jt1a-ev3J3LxJLGyPzIR6pqy7BQMwtVtxQnE9BxKWhMqD4bq-nl4UFBE-4IUeEZHa8RgmASAIHJThbqi6XpbafaucCkpveg');
        }
        return () => {
            if (isLoaded) {
                try {
                    handleClick();
                    setAppLoaded(false);
                } catch (e) {
                    console.error("error", e);
                }
            }
        };
    }, [isLoaded]);

    const loadingPercentage = Math.round(loadingProgression * 100);

    
    return (
        <Box sx={{ height: 'calc(100vh - 183px)', borderRadius: '18px', border: `1px solid ${themeData.palette.customBorderColor.main}` , justifyContent: 'center' }} className="container">
            {isLoaded === false && (
                <div className="loading-overlay" style={{display:'flex', height:'100%', alignItems:'center', justifyContent:'center'}} >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems:'center', flexDirection:'column'}}>
                        <p style={{ fontSize: '14px', color: themeData.palette.text.primary, marginBottom:'10px' }}>Loading... ({loadingPercentage}%)</p>
                        <LinearProgress sx={{width:'300px'}} variant="buffer" value={loadingPercentage} valueBuffer={0} />
                    </div>
                  
                </div>
            )}

            {appLoaded && <Unity matchWebGLToCanvasSize={true} style={{ height: '100%', width: '100%', borderRadius: '18px', }} unityProvider={unityProvider} devicePixelRatio={window.devicePixelRatio} />}
        </Box>)
}

const mapStateToProps = (state: any) => ({
    sceneData: state.digitalTwin.sceneData,
    libraryData: state.digitalTwin.libraryData,
});

export default connect(mapStateToProps)(UnityPlayer);
